// extracted by mini-css-extract-plugin
export default {"section":"RecommendedRings_section__9oeqT"};